import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';


const useStyle = makeStyles(() => ({
    tab: {
        '& .MuiBox-root': {
            padding: '0px',
        },
        '& .MuiTab-textColorInherit': {
            opacity: 1,
        },
     
    },
    tabs: {
        "& .MuiTab-wrapper": {
            flexDirection: "row",
            justifyContent: "flex-start",
            paddingLeft: 0,
            fontSize: 16,
            textTransform: 'none',
            fontWeight: 600,
            paddingTop: 0,
        },

        "& .MuiTab-textColorInherit.Mui-selected": {
            opacity: 1,
            color: 'white',
            backgroundColor: '#555263',
            borderRadius: 10,
        },
        '& .MuiTab-textColorInherit': {
            opacity: 1,
        },
        "& .MuiBox": {
            padding: 0,
        },
        "& .MuiTab-root": {
            maxWidth: 'fit-content',
            minWidth: 'auto',
            minHeight: 'auto',
            paddingLeft: 12,
            paddingRight: 12,
        },
        root: {
            paddingLeft: 0,
            paddingTop: 0,
        },
        MuiBox: {
            padding: 0,
        },
        MuiButtonBase: {
            paddingLeft: 0,
        }
    }
}));

function TabPanel(props) {
    const {
        children,
        value,
        index,
        ...other
    } = props;
    return ( < div role = "tabpanel"
        hidden = {
            value !== index
        }
        id = {
            `vertical-tabpanel-${index}`
        }
        aria-labelledby = {
            `vertical-tab-${index}`
        }
        {
            ...other
        } >
        {
            value === index && ( <Box p = {3}> <Typography> {children} </Typography> </Box>)
        } </div>);
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}
function OurSolutionsIndustries() {
  const classes = useStyle();
  const globalClasses = globalUseStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
 return (
    <ThemeProvider theme={theme}>
      <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
          <Grid className={globalClasses.containerSmall} container >
            <Grid item xs={12} md={12}  >
                <Typography  variant="subtitle1">What We Know</Typography>
                <Typography  variant="h2">Industries We Serve</Typography>
            </Grid>
            <Grid className={globalClasses.bottomSpacing} item xs={12} md={5}>
                <Tabs TabIndicatorProps={{
                style: {
                display:"none",
                }
                }}
                orientation="vertical"
                value={value}
                onChange={handleChange}
                className={classes.tabs}
                >
                <Tab className={globalClasses.hoverStyle} label="Patient Safety" {...a11yProps(0)} />
                <Tab className={globalClasses.hoverStyle}  label="QCDR" {...a11yProps(1)} />
                <Tab className={globalClasses.hoverStyle}  label="Claims Adjustment" {...a11yProps(2)} />
                <Tab className={globalClasses.hoverStyle}  label="Caregiver and Patient Centered Care" {...a11yProps(3)} />
                <Tab className={globalClasses.hoverStyle}  label="Risk Adjustment" {...a11yProps(4)} />
                <Tab className={globalClasses.hoverStyle}  label="EMR Integration" {...a11yProps(5)} />
                <Tab className={globalClasses.hoverStyle}  label="Performance Measure and Quality Improvement" {...a11yProps(6)} />
                </Tabs>
            </Grid>
            <Grid item xs={false} md={1} />
            <Grid item xs={12} md={6} >
                <TabPanel value={value} index={0} className={classes.tab}>
                  <Typography variant="h4">Patient Safety</Typography>
                  <Divider style={{marginTop:10, marginBottom: 10}} />
                  <Typography variant="body2">Fundamental to the bettering of health care, patient safety relies on continuous improvement and learning based on past errors and experiences. The patient safety field aims to prevent and reduce risk within the healthcare industry. </Typography>
                </TabPanel>
                <TabPanel value={value} index={1} className={classes.tab}>
                  <Typography  variant="h4">QCDR</Typography>
                  <Divider style={{marginTop:10, marginBottom: 10}} />
                 <Typography variant="body2">Fundamental to the bettering of health care, patient safety relies on continuous improvement and learning based on past errors and experiences. The patient safety field aims to prevent and reduce risk within the healthcare industry. </Typography>
                </TabPanel>
                <TabPanel value={value} index={2} className={classes.tab}>
                  <Typography variant="h4">Claims Adjustment</Typography>
                  <Divider style={{marginTop:10, marginBottom: 10}} />
                  <Typography variant="body2">Fundamental to the bettering of health care, patient safety relies on continuous improvement and learning based on past errors and experiences. The patient safety field aims to prevent and reduce risk within the healthcare industry. </Typography>
                </TabPanel>
                <TabPanel value={value} index={3} className={classes.tab}>
                  <Typography variant="h4">Caregiver and Patient Centered Care</Typography>
                  <Divider style={{marginTop:10, marginBottom: 10}} />
                  <Typography variant="body2">Fundamental to the bettering of health care, patient safety relies on continuous improvement and learning based on past errors and experiences. The patient safety field aims to prevent and reduce risk within the healthcare industry. </Typography>
                </TabPanel>
                <TabPanel value={value} index={4} className={classes.tab}>
                  <Typography variant="h4">Risk Adjustment</Typography>
                  <Divider style={{marginTop:10, marginBottom: 10}} />
                  <Typography variant="body2">Fundamental to the bettering of health care, patient safety relies on continuous improvement and learning based on past errors and experiences. The patient safety field aims to prevent and reduce risk within the healthcare industry. </Typography>
                </TabPanel>
                <TabPanel value={value} index={5} className={classes.tab}>
                  <Typography variant="h4">EMR Integration</Typography>
                  <Divider style={{marginTop:10, marginBottom: 10}} />
                  <Typography variant="body2">Fundamental to the bettering of health care, patient safety relies on continuous improvement and learning based on past errors and experiences. The patient safety field aims to prevent and reduce risk within the healthcare industry. </Typography>
                </TabPanel>
                <TabPanel value={value} index={6} className={classes.tab}>
                  <Typography variant="h4">Performance Measure and Quality Improvement</Typography>
                  <Divider style={{marginTop:10, marginBottom: 10}} />
                  <Typography variant="body2">Fundamental to the bettering of health care, patient safety relies on continuous improvement and learning based on past errors and experiences. The patient safety field aims to prevent and reduce risk within the healthcare industry. </Typography>
                </TabPanel>
            </Grid>
          </Grid>
      </Container>
    </ThemeProvider>
  );
};

export default OurSolutionsIndustries;